import Vue from 'vue'
window.Vue = Vue
import App from './App'
import navbar from './components/Navbar'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleLeft, faAngleRight, faBars, faTimes, faExternalLinkSquareAlt, faHome, faCaretSquareLeft } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faVimeo, faBehance, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFacebookF)
library.add(faTwitter)
library.add(faVimeo)
library.add(faBehance)
library.add(faInstagram)
library.add(faAngleLeft)
library.add(faAngleRight)
library.add(faBars)
library.add(faTimes)
library.add(faExternalLinkSquareAlt)
library.add(faHome)
library.add(faCaretSquareLeft)

Vue.component('font-awesome-icon', FontAwesomeIcon)

var version = '1.0.2'
console.log('version', version)

/* eslint-disable no-new */
new Vue({
  router,
  components: {
    'navbar': navbar
  },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js